import { render, staticRenderFns } from "./Credentials.vue?vue&type=template&id=ff1c54da&scoped=true&"
import script from "./Credentials.vue?vue&type=script&lang=ts&"
export * from "./Credentials.vue?vue&type=script&lang=ts&"
import style0 from "./Credentials.vue?vue&type=style&index=0&id=ff1c54da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1c54da",
  null
  
)

export default component.exports